import { Deserializable } from '../../deserializable';

export class BasePlaceholderDto implements Deserializable {
  public CaseNumber: number;
  public ApplicantIdentifier: string;
  public Code: string;
  public Type: string;
  public InformationRequest: string;
  public InformationRequestDescription: string;
  public ProvidedDocumentTypeCode: string;
  public PriorityCode: string;
  public Notes: string;
  public IsOriginalRequired: boolean;
  public Category: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
